import { Button, makeStyles, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { EnvVarRow } from './EnvVarRow';

const useStyles = makeStyles(theme => ({
  envVarsSection: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
  },
}));

interface LambdaEnvVarsEditorProps {
  envVars: Record<string, string>;
  onUpdate: (key: string, value: string) => void;
  onAdd: () => void;
  onDelete: (key: string) => void;
  onRename: (oldKey: string, newKey: string) => void;
  title?: string;
  description?: string;
}

export const LambdaEnvVarsEditor = ({
  envVars,
  onUpdate,
  onAdd,
  onDelete,
  onRename,
  title = 'Environment Variables',
  description,
}: LambdaEnvVarsEditorProps) => {
  const classes = useStyles();

  return (
    <div className={classes.envVarsSection}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
        }}
      >
        <div>
          <Typography variant="subtitle2">{title}</Typography>
          {description && (
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ fontSize: '0.75rem', marginTop: 4 }}
            >
              {description}
            </Typography>
          )}
        </div>
        <Button size="small" variant="outlined" startIcon={<AddIcon />} onClick={onAdd}>
          Add Variable
        </Button>
      </div>
      {envVars && Object.keys(envVars).length > 0 ? (
        Object.entries(envVars).map(([envKey, envValue], index) => (
          <EnvVarRow
            key={index}
            envKey={envKey}
            envValue={envValue}
            onUpdate={onUpdate}
            onDelete={onDelete}
            onRename={onRename}
          />
        ))
      ) : (
        <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }}>
          No environment variables configured
        </Typography>
      )}
    </div>
  );
};
